import { WbsItemType } from '../../../../domain/entity/WbsItemEntity'
import { ProgressReportScopeType } from '../../../../domain/entity/version-report/VersionReportVersionEntity'
import { DescendantRow } from '../../../../domain/value-object/ProjectPlanSnapshot'
import { DrilldownSource } from '../hooks/useDeliverableTaskSnapshot'

/**
 * セルの内訳の取り方と、そこから集計対象（成果物／タスク）の行だけを残す条件。
 *
 * shouldCountTicketsAsDeliverables はチケット別進捗状況の行。成果物の欄にチケット、
 * タスクの欄にチケット配下のタスクを数えているので、内訳もそれに合わせる。
 */
export const toDrilldown = (
  scopeType: ProgressReportScopeType,
  shouldCountTicketsAsDeliverables: boolean,
  aggregateTarget: WbsItemType | undefined
): { source: DrilldownSource; matches: (row: DescendantRow) => boolean } => {
  if (shouldCountTicketsAsDeliverables) {
    return aggregateTarget === WbsItemType.TASK
      ? {
          // 管理表の配下から、チケット自身（管理表に属するもの）を除いたタスク
          source: 'DESCENDANTS',
          matches: row =>
            row.type === WbsItemType.TASK && !row.wbsItem.ticketListUuid,
        }
      : { source: 'TICKETS', matches: () => true }
  }
  return {
    source: scopeType === 'TICKET_LIST' ? 'TICKETS' : 'DESCENDANTS',
    matches: row => !aggregateTarget || row.type === aggregateTarget,
  }
}
